export default __webpack_public_path__ + "18dc88ba9fb7d7e0b4bcdfc8eae12ac5.svg";